import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function AvIntegration() {
  return <DetailPage type="service" id="av-integration" />;
}
